module.exports = __webpack_public_path__ + "assets/img/861587017601_.pic_hd.37d7b492.jpg";